// extracted by mini-css-extract-plugin
module.exports = {"baseSectionMessage":"baseSectionMessage--N1N8L","message":"message--5lEIA","button":"button--YX90j"};